import React, { useState, useEffect, useContext } from "react";

import {
  loginContext,
  customerContext,
  valueContext,
} from "../context/contexts";
import { getKeyByValue } from "../context/contextmanager";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, TextField, MenuItem } from "@mui/material";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import { Button } from "@mui/material";
import { getobj, updateobj, dltobj } from "../apicall/apicall";
import { useLocation } from "react-router-dom";
import { timeStamp } from "../apicall/commonFunction";
import {
  StyledTableRow,
  StyledTableCell,
  buttonPosition,
  Root,
} from "../style/style";
import AddDevice from "./AddDevice";
import ArrowBack from "@mui/icons-material/ArrowBack";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Pagination from "@mui/material/Pagination";
import { Link } from "@mui/material";
import { validated } from "../apicall/validateform";
import GetAppIcon from "@mui/icons-material/GetApp";
import LoadingButton from "@mui/lab/LoadingButton";

export default function Devices(props) {
  const [devices, setdevices] = useState();
  const [addDevice, setaddDevice] = useState(false);
  const [loaded, setloaded] = useState(true);
  const [refresh, setrefresh] = useState(false);
  const [page, setpage] = useState(
    sessionStorage.getItem("page_number")
      ? parseInt(sessionStorage.getItem("page_number"))
      : 1,
  );
  const [hubs, sethubs] = useState();
  const [open, setopen] = useState(false);
  const [hub_id, sethub_id] = useState({});

  const [totalpage, setpaget] = useState(1);
  const loc = useLocation();
  //console.log(loc.pathname);

  const valc = useContext(valueContext);
  // console.log(valc);

  const [isExporting, setIsExporting] = useState(false);

  const handlePagechange = (event, value) => {
    setloaded(true);
    let url = "";
    if (props.search !== "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/" +
        props.id +
        "/?page=" +
        value +
        "&status=CONNECTED&search=" +
        props.search;
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/" +
        props.id +
        "/?page=" +
        value +
        "&status=CONNECTED";
    }
    const d = getobj(url);
    d.then(function (res) {
      setdevices(res.results);

      setloaded(false);
      setpage(value);
    });
  };

  const handleBack = () => {
    sessionStorage.removeItem("page_number");

    const nm = getKeyByValue(context.page, true);
    context.setpage({
      ...context.page,
      [nm]: false,
      Organizations: true,
    });
  };
  const handleaction = (id, val, type, mac_address, hub) => {
    console.log(id, val);

    if (val === "Detail") {
      sessionStorage.setItem("page", null);
      sessionStorage.setItem("page_number", page);
      sessionStorage.setItem("value", 1);
      handleClick(id);
    } else if (val === "Terminate") {
      if (type === "NA") {
        NotificationManager.info(
          "The device will be permanently deleted after this billing period, To add it again contact Admin.",
        );
      } else {
        NotificationManager.info(
          "The Device and sim will be deactivated. To delete it permanently please contact admin.",
        );
      }
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r.status === 200) {
          //NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Could not deletd.", "Failed", 2000);
        }
      });
    } else if (val === "Delete") {
      console.log("delete");
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "device/add-device/?delete_type=delete";
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r.status === 200) {
          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error("Could not deletd.", "Failed", 2000);
        }
      });
    } else if (val === "unlink") {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "hub/connect/0/?mac_address=" +
        mac_address +
        "&action=unlink&hub_id=" +
        hub;
      updateobj(url, {}).then(function (res) {
        if (res.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message, 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(res.Message, "Unlinked", 2000);

          setrefresh(!refresh);
        }
      });
    } else if (val === "link") {
      sethub_id({
        ...hub_id,
        mac_address: mac_address,
      });
      setopen(true);
    } else {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: id, active_status: status };
      updateobj(url, data).then(function (data) {
        if (data.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(data.Message, "Updated", 2000);

          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(data.Message, "Failed", 2000);
        }
      });
    }
  };

  useEffect(() => {
    console.log(props);
    let url;
    if (props.search === "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/" +
        props.id +
        "/?page=" +
        page +
        "&status=CONNECTED";
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/" +
        props.id +
        "/?search=" +
        props.search +
        "&status=CONNECTED";
      setpage(1);
    }

    const d = getobj(url);
    d.then(function (res) {
      if (res.results.length > 0) {
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }
      }
      setdevices(res.results);
      setloaded(false);
    });
    const url2 = process.env.REACT_APP_ZEWA_URL + "hub/list/" + props.id + "/";
    const res2 = getobj(url2);
    res2.then(function (res2) {
      sethubs(res2);
    });
  }, [props.id, addDevice, props.search, page, props, refresh]);

  const context = useContext(loginContext);
  const context2 = useContext(customerContext);

  const handleExport = async () => {
    try {
      setIsExporting(true);

      // Build query parameters
      let params = `customer_id=${props.id}`;

      let search = props.search;
      if (search && search.length > 0) {
        params += `&search=${encodeURIComponent(search)}`;
      }

      const url = `${process.env.REACT_APP_ZEWA_URL}device/export-devices/?${params}`;

      // Show feedback for potentially large exports
      const startTime = Date.now();

      const response = await getobj(url);

      const duration = (Date.now() - startTime) / 1000;
      console.log(
        `Export completed in ${duration}s for ${response.length} records`,
      );

      if (response && Array.isArray(response)) {
        // Convert array of arrays to CSV
        const csvContent = response
          .map((row) => {
            // Escape values that contain commas or quotes
            return row
              .map((cell) => {
                if (cell === null || cell === undefined) {
                  return "";
                }
                const cellStr = String(cell);
                if (cellStr.includes(",") || cellStr.includes('"')) {
                  return `"${cellStr.replace(/"/g, '""')}"`;
                }
                return cellStr;
              })
              .join(",");
          })
          .join("\n");

        // Create blob and download
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        const filename = `DeviceList_${new Date().getTime()}.csv`;
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        NotificationManager.success(
          "Devices exported successfully.",
          "Export Successful",
          2000,
        );
      } else {
        NotificationManager.error(
          "Invalid response from server.",
          "Export Failed",
          2000,
        );
      }
    } catch (error) {
      console.error("Error exporting devices:", error);
      NotificationManager.error(
        "Failed to export devices.",
        "Export Failed",
        2000,
      );
    } finally {
      setIsExporting(false);
    }
  };

  const handleClick = (id) => {
    if (loc.pathname === "/admin") {
      context.setid(id);
      const nm = getKeyByValue(context.page, true);
      context.setpage({
        ...context.page,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (loc.pathname === "/customer") {
      context.setid(id);
      const nm = getKeyByValue(context2.manage, true);
      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (loc.pathname === "/user") {
      context.setid(id);
      const nm = getKeyByValue(context2.manage, true);
      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (
      loc.pathname === "/distributor" ||
      loc.pathname === "/distributor-user"
    ) {
      console.log(id);
      context.setid(id);
      props.devicedetail.setdevicedetail(true);
    }
  };
  const handlehublin = (hub_id) => {
    console.log(hub_id, validated(hub_id));
    if (validated(hub_id) && hub_id["hub_id"]) {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "hub/connect/0/?mac_address=" +
        hub_id.mac_address +
        "&action=link&hub_id=" +
        hub_id.hub_id;
      const res = updateobj(url, {});
      res.then(function (res) {
        if (res.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message, 2000);
          setopen(false);
          sethub_id({});
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(res.Message, "Unlinked", 2000);

          setopen(false);
          sethub_id({});
          setrefresh(!refresh);
        }
      });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please select a Hub to link to");
    }
  };

  const handleLink = (hubid) => {
    context.sethub(hubid);
    sessionStorage.setItem("value", "5");
    sessionStorage.setItem("hub_d", true);
    if (loc.pathname === "/admin") {
      //console.log("clicked",hubid)

      valc.setvalue("5");
    } else if (
      loc.pathname === "/distributor" ||
      loc.pathname === "/distributor-user"
    ) {
      props.value.setvalue("2");
    } else {
      const nm = getKeyByValue(context2.manage, true);
      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        Hubs: true,
      });
    }
  };

  const hubContent = (device) => {
    if (device.hub_id === null) {
      return "NA";
    } else if (!device.hub_id.delete_status) {
      return (
        <Link
          onClick={() => {
            handleLink(device.hub_id["id"]);
          }}
        >
          {device.hub_id["hub_id"]}
        </Link>
      );
    } else {
      return device.hub_id["hub_id"];
    }
  };

  return (
    <Root>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <div>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {loc.pathname === "/admin" && (
              <Button onClick={handleBack} startIcon={<ArrowBack />}></Button>
            )}

            <Box
              sx={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginTop: "10px",
                marginRight: "10px",
              }}
            >
              {devices && devices.length > 0 && (
                <LoadingButton
                  onClick={handleExport}
                  loading={isExporting}
                  endIcon={<GetAppIcon />}
                  variant="contained"
                  color="primary"
                  sx={{ margin: "5px" }}
                >
                  Export Device List
                </LoadingButton>
              )}

              {!addDevice && (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddToQueueIcon />}
                  onClick={() => {
                    setaddDevice(!addDevice);
                  }}
                >
                  Add Device
                </Button>
              )}
            </Box>
          </Box>
          {!addDevice ? (
            <Box sx={{ marginRight: "30px" }}>
              {devices && devices.length > 0 ? (
                <Box>
                  <TableContainer>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>
                            <b>Device Group</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b>Model</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b>Bluetooth ID</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b>IMEI</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b>HUB</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b>Status</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b>Last Active</b>
                          </StyledTableCell>
                          <StyledTableCell>
                            <b> Comments</b>
                          </StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {devices
                          ? devices.map((device) => (
                              <StyledTableRow key={device.id}>
                                <StyledTableCell>
                                  {device.group}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {device.model}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {device.mac_address}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {device.imei_number}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {hubContent(device)}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {device.active_status === false
                                    ? "Inactive"
                                    : "Active"}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {device.utc === "NA"
                                    ? "No Data"
                                    : device.imei_number === "NA"
                                      ? timeStamp(parseInt(device.utc))
                                      : timeStamp(parseInt(device.utc, 16))}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {device.comments}
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Button>
                                    <TextField
                                      select
                                      name="device_name"
                                      id="deviceName"
                                      sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                      variant="outlined"
                                      label="Action"
                                      value={""}
                                      onChange={(e) => {
                                        handleaction(
                                          device.id,
                                          e.target.value,
                                          device.imei_number,
                                          device.mac_address,
                                          device.hub_id == null
                                            ? "NA"
                                            : device.hub_id["hub_id"],
                                        );
                                      }}
                                    >
                                      <MenuItem value="Detail">Detail</MenuItem>
                                      <MenuItem
                                        value={
                                          device.active_status
                                            ? "Deactivate"
                                            : "Activate"
                                        }
                                      >
                                        {device.active_status
                                          ? "Deactivate"
                                          : "Activate"}
                                      </MenuItem>
                                      {loc.pathname === "/admin" && [
                                        <MenuItem value="Terminate">
                                          Terminate
                                        </MenuItem>,
                                        props?.customerDetails &&
                                          props.customerDetails.billing_type ===
                                            "Yearly" && (
                                            <MenuItem value="Delete">
                                              Delete
                                            </MenuItem>
                                          ),
                                      ]}
                                      {device.imei_number === "NA" && (
                                        <MenuItem
                                          value={
                                            device.hub_id ? "unlink" : "link"
                                          }
                                        >
                                          {device.hub_id ? "Unlink" : "Link"}
                                        </MenuItem>
                                      )}
                                    </TextField>
                                  </Button>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))
                          : null}
                      </TableBody>
                      <Pagination
                        count={totalpage}
                        page={page}
                        variant="outlined"
                        color="primary"
                        onChange={handlePagechange}
                      />
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                <h4 style={{ fontFamily: "Roboto", textAlign: "center" }}>
                  No device added yet
                </h4>
              )}
            </Box>
          ) : (
            <AddDevice setaddDevice={setaddDevice} id={props.id} />
          )}
          <NotificationContainer />
        </div>
      )}
      <Dialog open={open} onClose={() => setopen(false)}>
        <DialogTitle>Link Hub</DialogTitle>

        <TextField
          select
          label="Select Hub"
          name="device_group"
          id="deviceName"
          sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
          variant="outlined"
          onChange={(e) => {
            sethub_id({
              ...hub_id,
              hub_id: e.target.value,
            });
          }}
        >
          {hubs &&
            hubs.map((i) => {
              return (
                <MenuItem value={i.hub_id} key={i.hub_id}>
                  {i.hub_id}
                </MenuItem>
              );
            })}
        </TextField>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setopen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handlehublin(hub_id);
            }}
          >
            Link
          </Button>
        </DialogActions>
      </Dialog>
    </Root>
  );
}
